<div>
  <div class="card-box">
    <h2 class="text-center" i18n>Choose number of monthly active users</h2>

    <div class="flex flex-col md:flex-row items-center gap-5 mt-3">
      <div class="block md:hidden px-5">
        <mat-form-field>
          <mat-label i18n>Monthly Active Users</mat-label>

          <mat-select [(ngModel)]="currentMAUIndex">
            @for (step of steps; track $index) {
              <mat-option [value]="$index">{{ step }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="relative">
        <div class="flex-row-center gap-2">
          <div [class.font-bold]="period() === SubscriptionPeriod.Monthly" i18n>Monthly</div>
          <div>
            <mat-slide-toggle
              [checked]="period() === SubscriptionPeriod.Annual"
              (toggleChange)="togglePeriod()"
            />
          </div>
          <div [class.font-bold]="period() === SubscriptionPeriod.Annual" i18n>Yearly</div>
        </div>

        @if (saveValue() > 0) {
          <div class="absolute left-0 -bottom-1 translate-y-full w-full text-center">
            <app-pill [color]="period() === SubscriptionPeriod.Annual ? 'green' : 'red'">
              <div class="flex-row-center gap-1">
                @if (period() === SubscriptionPeriod.Annual) {
                  <div i18n>Save</div>
                } @else {
                  <div i18n>Yearly to save</div>
                }
                <div>{{ saveValue() | currency: currency() : 'symbol' : '1.0-0' }}</div>
              </div>
            </app-pill>
          </div>
        }
      </div>

      <div class="hidden md:block flex-1 px-5">
        <mat-slider
          class="!w-full"
          min="0"
          [max]="steps.length - 1"
          step="1"
          showTickMarks
          discrete
          [displayWith]="formatLabel"
        >
          <input matSliderThumb [(ngModel)]="currentMAUIndex">
        </mat-slider>
      </div>

      <div class="text-xxl hidden md:block">
        {{ currentMAUValue() | bigNumber }}{{ (currentMAUIndex() === (steps.length - 1)) ? '+' : '' }} MAU
      </div>
    </div>
  </div>
</div>

<div class="mt-5 grid grid-cols-1 md:grid-cols-3 gap-3 items-stretch justify-center">
  <app-pricing-sub
    name="Free"
    [price]="SUBSCRIPTION_CHECKOUT_DATA[SubscriptionType.Free][period()].price[currency()]"
    [currency]="currency()"
    [period]="period()"
    [hideCTA]="true"
    featuresTitle="Includes:"
    [features]="FREE_FEATURES"
  />

  @let currentBaseSub = currentBaseSubscription();
  @let checkoutData = currentBaseSub ? SUBSCRIPTION_CHECKOUT_DATA[currentBaseSub.type][period()] : undefined;

  <app-pricing-sub
    [name]="checkoutData?.name ?? 'Base'"
    [letsTalk]="!currentBaseSub"
    [price]="checkoutData?.price?.[currency()] ?? 0"
    [currency]="currency()"
    [period]="period()"
    ctaText="Subscribe"
    featuresTitle="Free plus:"
    [features]="currentBaseSubscriptionFeatures()"
    (ctaClicked)="startSubscriptionAsync(currentBaseSub?.type)"
  />

  <app-pricing-sub
    name="Enterprise"
    [letsTalk]="true"
    [currency]="currency()"
    [period]="period()"
    ctaText="Subscribe"
    featuresTitle="Base plus:"
    [features]="ENTERPRISE_FEATURES"
  />
</div>
